// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3_sLr","label":"LabeledBox_label__16GLA"};